import axios from 'axios';
import { bigDataCloudApiKey } from '@/config';

export const getClientIP = async () =>
    axios
        .get(`https://api.bigdatacloud.net/data/ip-geolocation-with-confidence?key=${bigDataCloudApiKey}`)
        .then(({ data }) => data);
